import Button from "../Button";
import { Container } from "./styles";
import { ImCheckboxChecked } from "react-icons/im"
import CarouselImage from "../CarouselImage";

const RoomCard = ({selected, setSelectedRoom, id, name, capacity, description, images}) => {
    const placeholder = "https://patriciaelias.com.br/wp-content/uploads/2021/01/placeholder.png"

    return(
        <Container>
            <div>
                <div className="images">
                    <CarouselImage placeholder={placeholder} images_urls={images}/>
                </div>
                {/* <img src={images ? `${photo.defaults.baseURL + images[0]}` : placeholder} alt={`Quarto ${name}`}/> */}
                <div className="info">
                    <h2>
                        Quarto <br/>
                        {name}
                    </h2>
                    <ul>
                        <li>
                            Acomoda {capacity} pessoa(s)
                        </li>
                        <li>
                            {description}
                        </li>
                    </ul>
                    { !!selected ?
                        <Button format="submit" style={{background: "#007AFF"}} onClick={() => setSelectedRoom(id)}><ImCheckboxChecked /> Selecionado</Button>
                        :
                        <Button format="home" onClick={() => setSelectedRoom(id)}>Selecionar Quarto</Button>
                    }
                </div>
            </div>
        </Container>
        
    )
}

export default RoomCard;